import * as React from "react";


interface IFormProps {
    rooms_ids: any;
}
interface MyStates {

}
export default class FirstFloorPlan extends React.Component<IFormProps, MyStates>{

    constructor(props:IFormProps) {
        super(props);

        this.state = {

        }
    }

    public render () {
        let rooms_ids = this.props.rooms_ids;
        return(
            <div className="box">
                <div className="box-header">
                    <h3 className="box-title text-center">Emelet</h3>
                </div>
                <div className="box-body">
                    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 1920 1080">
                        <g>
                            <rect x="198" y="254.7" className={rooms_ids.filter(id => id === 1).length > 0 ? "st1" : "st2"} width="294.2" height="473.3"/>
                            <text x="278" y="490.7" font-size="35" fill="#ECECEC">11.szoba</text>
                        </g>
                        <g>
                            <rect x="1435.1" y="254.7" className={rooms_ids.filter(id => id === 8).length > 0 ? "st1" : "st2"} width="286.9" height="473.3"/>
                            <text x="1515.1" y="490.7" font-size="35" fill="#ECECEC">17.szoba</text>
                        </g>
                        <g>
                            <rect x="1246.9" y="254.7" className={rooms_ids.filter(id => id === 7).length > 0 ? "st1" : "st2"} width="188.2" height="243.8"/>
                            <text x="1275.9" y="384.7" font-size="35" fill="#ECECEC">16.szoba</text>
                        </g>
                        <g>
                            <rect x="1058.1" y="254.7" className={rooms_ids.filter(id => id === 6).length > 0 ? "st1" : "st2"} width="188.2" height="243.8"/>
                            <text x="1088.9" y="384.7" font-size="35" fill="#ECECEC">15.szoba</text>
                        </g>
                        <g>
                            <rect x="869.4" y="254.7" className={rooms_ids.filter(id => id === 5).length > 0 ? "st1" : "st2"} width="188.2" height="243.8"/>
                            <text x="899.4" y="384.7" font-size="35" fill="#ECECEC">14.szoba</text>
                        </g>
                        <g>
                            <rect x="680.7" y="254.7" className={rooms_ids.filter(id => id === 4).length > 0 ? "st1" : "st2"} width="188.2" height="243.8"/>
                            <text x="715.4" y="384.7" font-size="35" fill="#ECECEC">13.szoba</text>
                        </g>
                        <g>
                            <rect x="492.2" y="254.7" className={rooms_ids.filter(id => id === 3).length > 0 ? "st1" : "st2"} width="188.2" height="243.8"/>
                            <text x="525.4" y="384.7" font-size="35" fill="#ECECEC">12.szoba</text>
                        </g>

                        <polygon className="st2"
                                 points="198,254.7 1722,254.7 1722,728.1 1037.5,728.1 1037.5,825.3 363.3,825.3 363.3,728.1 198,728.1 "/>


                        <line className="st2" x1="1435.1" y1="498.5" x2="492.2" y2="498.5"/>

                        <line className="st2" x1="492.2" y1="727.1" x2="492.2" y2="254.7"/>
                        <line className="st2" x1="363.9" y1="728.1" x2="1037.5" y2="728.1"/>
                        <line className="st2" x1="1435.1" y1="254.7" x2="1435.1" y2="727.1"/>
                        <line className="st2" x1="680.7" y1="498.5" x2="680.7" y2="254.7"/>
                        <line className="st2" x1="869.3" y1="498.5" x2="869.3" y2="254.7"/>
                        <line className="st2" x1="1058.1" y1="498.5" x2="1058.1" y2="254.7"/>
                        <line className="st2" x1="1246.9" y1="498.5" x2="1246.9" y2="254.7"/>
                    </svg>
                </div>
            </div>

        );
    }
}
